export const CUSTOM_EVENT_OPEN_IMAGE_PREVIEW = 'open-image-preview'
export const CUSTOM_EVENT_CLOSE_IMAGE_PREVIEW = 'close-image-preview'
